import React from 'react'
import XLSX from 'xlsx'


function Workbook() {
    
    if (!(this instanceof Workbook))
        return new Workbook()

    this.SheetNames = []

    this.Sheets = {}
}

const download = (url, name) => {
    let a = document.createElement('a')
    a.href = url
    a.download = name
    a.click()

    window.URL.revokeObjectURL(url)
}

function processArrayValues(data) {
    return data.map(item => {
        let newItem = { ...item };
        for (let key in newItem) {
            if (Array.isArray(newItem[key])) {
                // 過濾空字串並將陣列轉為逗號分隔的字串
                newItem[key] = newItem[key].filter(value => value.trim() !== '').join(' , ');
            }
        }
        return newItem;
    });
}

function s2ab(s) {
    const buf = new ArrayBuffer(s.length)

    const view = new Uint8Array(buf)

    for (let i=0; i !== s.length; ++i)
        view[i] = s.charCodeAt(i) & 0xFF

    return buf
}

export default  data => {
    import('xlsx').then(XLSX => {
        const processedData = processArrayValues(data);

        const wb = new Workbook()
        const ws = XLSX.utils.json_to_sheet(processedData)

        wb.SheetNames.push('')
        wb.Sheets[''] = ws


        const wbout = XLSX.write(wb, {bookType:'csv', bookSST:true, type: 'binary'})


        let url = window.URL.createObjectURL(new Blob([s2ab(wbout)], {type:'application/octet-stream'}))
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, "0");
        const year = now.getFullYear() % 100; // 例如 2025 → 25

        const timestamp = `${pad(year)}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;

        download(url, `DeviceStatus_Data-${timestamp}.csv`)
    })
}